"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventQueue = void 0;
class EventQueue {
    constructor() {
        this.queue = [];
    }
    enqueue(method, args) {
        this.queue.push([method, ...args]);
    }
    dequeue() {
        return this.queue.shift();
    }
    batchDequeue(fn) {
        while (this.length > 0) {
            const event = this.dequeue();
            if (event) {
                fn(event);
            }
        }
    }
    get length() {
        return this.queue.length;
    }
}
exports.EventQueue = EventQueue;
//# sourceMappingURL=event-queue.js.map